<template>
    <div class="firstPage">
        <div class="content">
            <div class="imgBox"><img src="./../../../assets/newtask/uninstall.png" alt=""></div>
            <p class="title">系统会自动填写师父呦～</p>
            <p class="text">您还没有师傅可以填写,快去打开浏览器绑定师父吧</p>
            <p class="text">tips:本页面只会在安装后第一次打开软件时提示</p>
            <div class="btn" @click="backapp">返回App</div>
        </div>
    </div>
</template>

 <style lang="scss" scoped>
    .imgBox{
        width:1.3rem;
        height:1.55rem;
        margin:.7rem auto 0;
        color:#4A4A4A;
    }
    .title{
        width:100%;
        text-align: center;
        margin-top:.55rem;
        font-size: .22rem;
    }
    .text{
        width:100%;
        text-align: center;
        margin-top:.1rem;
        font-size: .14rem;
        color:#9B9B9B;
    }
    .btn{
        width:1.1rem;
        height:.4rem;
        margin:.7rem auto 0;
        background-image: linear-gradient(112deg, #FFDF42 0%, #FFEC77 100%);
        border-radius: .18rem;
        text-align:center;
        line-height: .4rem;
        font-size: .15rem;
    }
</style>

<script>

/**
 * @description 判断浏览器的隐身(无痕)模式
 */
var isPrivate = false;
try {
window.openDatabase(null, null, null, null);
} catch (_) {
isPrivate = true;
}
console.log(isPrivate)

export function browserIsHide () {
  let fs = window.RequestFileSystem || window.webkitRequestFileSystem;

  if (!fs) {
    console.log("check failed?");
  } else {
    fs(window.TEMPORARY,100,function(){
      console.log('非无痕模式')
    },function(){
    isPrivate = true;
    });
  }
}
browserIsHide ();
/**以下方式判断错误，在无痕模式下，localStorage依旧可以使用*/
if(typeof localStorage === 'object'){
  try{
    localStorage.setItem('localStorage', 1);
    localStorage.removeItem('localStorage');
  }catch(e){
    Storage.prototype._setItem = Storage.prototype.setItem;
    Storage.prototype.setItem = function() {};
    isPrivate = true;
  };
};
export default {
    methods:{
        backapp(){
            window.location.href = "wanzhuanweilai://version=1"
        },
        getPara(url){
            if(url.indexOf("?")>-1){           //判断分割的位置
                var result=[];
                var paraStr=url.split("?")[1];   //从"share/?"开始分割
                var paraItems=paraStr.split("&");
                for(var i=0;i<paraItems.length;i++){
                var paraKey=paraItems[i].split("=")[0];
                var paraValue=paraItems[i].split("=")[1];
                result.push({
                    key:paraKey,                //打印result会得到多个json数据
                    value:paraValue
                    })
                }	
            this.userID = result[0].value        //提取result下标为0的键值
            this.$cookies.set("sonID", this.userID)
            console.log("存储徒弟id成功")
            }else{
                console.log("该URL中不含参数")
            }
        },
    },
    mounted(){
        let url = this.$el.baseURI
        this.getPara(url)

    if(isPrivate){
    alert("您处于无痕浏览，请关闭无痕模式，并刷新页面");
    }else{
        this.$axios.post("/api/user/saveparent", {
            uid: this.$cookies.get("sonID"),
            pid: this.$cookies.get("userID")|| "-1",
            request_time : Date.parse(new Date()),
        }).then(res=>{
            window.location.href = "wanzhuanweilai://"
        })
        }
    }
}
</script>
